export function digitSeperator(x) {
  const regEx = new RegExp(/\B(?=(\d{3})+(?!\d))/g);
  if (typeof x === 'undefined') {
    x = '';
    return x;
  }
  return x.toString().replace(regEx, ',');
}

export function digitDeSeperator(x) {
  if (typeof x === 'undefined') {
    x = '';
    return x;
  }
  return x.toString().replaceAll(',', '');
}

export const truncateText = (text, length = 20) => {
  return text.length > length ? text.slice(0, length) + '...' : text;
};
